import * as types from 'core/actionTypes';
import { api, alert, Analytics } from 'utils';
import { showPushNotificationPrompt } from 'modules/activity/activity.actions';
import { API_URL } from 'utils/env';

const Alert = alert.Alert();

export function setCreatePostState(state) {
  return {
    type: types.SET_CREATE_POST_STATE,
    payload: state,
  };
}

export function setPostCategory(tag) {
  const set = tag || null;
  return {
    type: 'SET_POST_CATEGORY',
    payload: set,
  };
}

export function clearCreatePost() {
  return {
    type: 'CLEAR_CREATE_POST',
  };
}

export function submitPost(post, viaShare) {
  return async (dispatch) => {
    try {
      const newPost = await dispatch(
        api.request({
          method: 'POST',
          endpoint: 'post',
          body: JSON.stringify(post),
        })
      );
      dispatch(
        showPushNotificationPrompt({
          type: 'createPost',
        })
      );
      Analytics.logEvent('newPost', {
        viaShare,
      });
      return newPost;
    } catch (err) {
      Alert.alert(`Error creating post: ${err.message}`);
      return false;
    }
  };
}

// TODO update to use api util
export function generatePreviewServer(link) {
  return () =>
    fetch(API_URL + '/api/post/preview/generate?url=' + encodeURIComponent(link), {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((responseJSON) => responseJSON)
      .catch(Alert);
}
